import { jsx as _jsx } from "react/jsx-runtime";
import CircularProgress from "@mui/material/CircularProgress";
export const CircularProgressIcon = (props = {}) => {
    const { width, height, } = props;
    const output = (_jsx(CircularProgress, { variant: "indeterminate", color: "primary", size: width || height }));
    return output;
};
